<template>
  <!-- Foto-Auslesen (Trello "WMS - mobile Version", P4-P7): oeffnet die Kamera, schickt das
       komprimierte Bild an /warehouses/extract und meldet den Vorschlag an den Parent. -->
  <button type="button" class="m-wms-form__iconbtn" :disabled="busy" @click="$refs.file.click()">
    <i class="material-icons">{{ busy ? "hourglass_top" : "photo_camera" }}</i>
    <input ref="file" type="file" accept="image/*" capture="environment" style="display: none" @change="onFile" />
  </button>
</template>

<script>
import { compressImage } from "@/helpers/imageCompress";
import WarehouseService from "@/services/warehouse.service";

export default {
  name: "MWmsPhotoButton",
  props: {
    kind: { type: String, required: true }, // "ean" | "location"
  },
  data() {
    return { busy: false };
  },
  methods: {
    async onFile(ev) {
      const file = ev.target.files && ev.target.files[0];
      ev.target.value = "";
      if (!file || this.busy) return;
      this.busy = true;
      try {
        const compressed = await compressImage(file);
        const result = await WarehouseService.extractFromPhoto(compressed, this.kind);
        this.$emit("extracted", result);
      } catch (e) {
        this.$emit("extract-error");
      } finally {
        this.busy = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped src="./m-wms.scss"></style>
